import React from 'react';
import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
//import logo from './logo.svg';
import './App.css';
import { LoginPage } from './LoginPage'
import { HomePage } from './HomePage'
import { RegisterPage } from './RegisterPage'
import 'bootstrap/dist/css/bootstrap.min.css';
import { CreditCardPage } from './CreditCardPage';
import { NotFoundPage } from './NotFoundPage';
import { PrePaidCounters } from './PrePaidCounters';
import { CreditCardDirectDebit } from './CreditCardDirectDebit/CreditCardDirectDebit';
import { userService } from './_services/user.service';
import { PaymentFile } from './PaymentFile/PaymentFile';


//import {Button, Form, FormControl, Nav, Navbar, NavDropdown} from "react-bootstrap";
//import Navbar from "react-bootstrap/esm/Navbar";
//import Nav from "react-bootstrap/esm/Nav";
//import NavDropdown from "react-bootstrap/esm/NavDropdown";
//import { Link } from 'react-router-dom';
const RequireAuth = ({ children }) => {
  let myUser = userService.getUser();
  if (!myUser) {
    return <Redirect to='/login' />;
  }
  return children;
};

function App() {
  console.log('App.js ---')

  return (
    <BrowserRouter>
      <div className="App">
        <main>
          <Switch>

            <Route path="/login" component={LoginPage} exact />
            <Route path="/register" component={RegisterPage} />
            <RequireAuth>
              <Route path="/" component={HomePage} exact />
              <Route path="/credit_card" component={CreditCardPage} />
              <Route path="/prepaid" component={PrePaidCounters} />
              <Route path="/cc-dd" component={CreditCardDirectDebit} />
              <Route path="/payment-file" component={PaymentFile} />
              {/* <Route component={NotFoundPage} /> */}
            </RequireAuth>
            <Route component={NotFoundPage} />

          </Switch>
        </main>
      </div>
    </BrowserRouter>
  );
}



//export default withTranslation()(App);
export default App;
